import React from 'react';
import { Button } from '../../components/ui/button';
import { Phone, Sparkles } from 'lucide-react';
import { Confetti } from '../../components/ui/confetti';

export function LeadOnboardingOverlay({
  showConfetti, onConfettiComplete,
  highlightedLeadId, onboardingStep,
  highlightedCardRef,
  onAICallAction, onDismissOnboarding,
}) {
  return (
    <>
      {/* Iter 59b — full-screen confetti removed from lead onboarding.
          The existing pulsing-highlight on the card provides ample celebration
          without obscuring the first lead the user came to see. */}
      {/* <Confetti
        active={showConfetti}
        particleCount={80}
        duration={1400}
        onComplete={onConfettiComplete}
      /> */}

      {highlightedLeadId && onboardingStep && (
        <>
          {onboardingStep === 'highlight' && (
            <div className="fixed z-[100] animate-in fade-in slide-in-from-left-2 duration-300" 
              style={{
                top: highlightedCardRef.current ? 
                  highlightedCardRef.current.getBoundingClientRect().top + 20 : '50%',
                left: highlightedCardRef.current ? 
                  highlightedCardRef.current.getBoundingClientRect().right + 16 : '50%',
              }}
            >
              <div 
                className="text-white px-4 py-3 rounded-lg shadow-xl max-w-[280px]"
                style={{ backgroundColor: 'hsl(215, 100%, 56%)' }}
              >
                <p className="text-sm font-medium mb-3">Great! Your First Lead is created.</p>
                <Button 
                  size="sm" 
                  onClick={onAICallAction}
                  className="w-full bg-card hover:bg-card/90 text-xs h-8"
                  style={{ color: 'hsl(215, 100%, 56%)' }}
                  data-testid="onboarding-call-with-ai-btn"
                >
                  <Phone className="h-3 w-3 mr-1.5" />
                  Call with AI
                </Button>
                <button 
                  onClick={onDismissOnboarding}
                  className="w-full text-center text-xs opacity-70 hover:opacity-100 transition-opacity mt-2"
                  data-testid="onboarding-maybe-later-btn"
                >
                  Maybe later
                </button>
                <div 
                  className="absolute top-6 -left-2 w-0 h-0 border-t-8 border-b-8 border-r-8 border-transparent"
                  style={{ borderRightColor: 'hsl(215, 100%, 56%)' }}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
